import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f484340"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "session-inline"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fin de session imminente", -1))

import {
  sessionPopupOpen,
  sessionRemainingLabel,
  sessionState,
  initSessionTimer,
} from "@/services/session.services";
import {
  IonToast,
  IonIcon,
  useIonRouter,
} from "@ionic/vue";
import { timeOutline } from "ionicons/icons";
import { computed, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionExpiryIndicator',
  props: {
  inline: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const router = useIonRouter();

const showWarning = computed(
  () => sessionState.value === "warning" || sessionState.value === "critical"
);

const toastOpen = computed(
  () => sessionPopupOpen.value && showWarning.value
);

const toastMessage = computed(
  () => `Fin de session imminente — ${sessionRemainingLabel.value}`
);

const closePopup = () => {
  sessionPopupOpen.value = false;
};

onMounted(() => {
  initSessionTimer();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonToast), {
      "is-open": toastOpen.value,
      message: toastMessage.value,
      duration: 4000,
      position: "top",
      "css-class": "session-toast",
      onDidDismiss: closePopup
    }, null, 8, ["is-open", "message"]),
    (__props.inline && showWarning.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(IonIcon), {
            icon: _unref(timeOutline),
            size: "small"
          }, null, 8, ["icon"]),
          _hoisted_2
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})